import {useWorkspace} from '../workspace/WorkspaceContext';
import {AIModelId, Ticket} from '../types';

interface SelectorProps {testId: string; disabled?: boolean; label?: string}
export const AIModelSelector = ({testId, disabled = false, label = 'AI model for triage and the next reply'}: SelectorProps) => {
  const {aiSettings, modelSaving, selectModel} = useWorkspace();
  return <select className="draft-tone ai-model-select" aria-label={label} title={label}
    value={aiSettings?.selected_model_id ?? ''} disabled={disabled || modelSaving || !aiSettings}
    onChange={event => { void selectModel(event.target.value as AIModelId); }} data-testid={testId}>
    {!aiSettings && <option value="">AI unavailable</option>}
    {aiSettings?.models.map(model => <option key={model.id} value={model.id}>{model.label}</option>)}
  </select>;
};

const RECORDED_MODEL_LABELS: Readonly<Record<AIModelId, string>> = {
  'gpt-6-luna': 'GPT-6 Luna',
  'claude-sonnet-5': 'Claude Sonnet 5',
};

export const DraftModelLabel = ({ticket, processing = false}: {ticket: Ticket; processing?: boolean}) => {
  const modelId = ticket.draft_model_id ?? ticket.triage_model_id;
  const name = modelId ? RECORDED_MODEL_LABELS[modelId] : undefined;
  let label = ticket.is_sample ? 'Sample conversation' : 'Reply draft';
  if (name) label = `${name} · ${ticket.draft_model_id ? 'reply' : 'triage'}`;
  if (processing) label = 'Preparing reply';
  // Attribution depends solely on saved ticket metadata, never the next-model preference.
  return <small data-testid="draft-model-label" data-processing={processing} title={label}>{label.toUpperCase()}</small>;
};

export const AIModelSettingsRow = () => {
  const {aiSettings} = useWorkspace();
  const current = aiSettings?.models.find(model => model.id === aiSettings.selected_model_id);
  return <div className="settings-row ai-model-settings-row">
    <div><h3>AI model</h3><p data-testid="settings-ai-model">{current?.label} · Classification and grounded reply drafting</p></div>
    <AIModelSelector testId="settings-ai-model-select" label="Workspace AI model"/>
  </div>;
};